/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Speaker_Manager_Table_NameInputs */



/**
* | output |
* | --- |
* | "Speaker Name" |
*
* @param {Speaker_Manager_Table_NameInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const speaker_manager_table_name = /** @type {((inputs?: Speaker_Manager_Table_NameInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Speaker_Manager_Table_NameInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Nom du locuteur")
	if (locale === "de") return /** @type {LocalizedString} */ ("Name des Sprechers")
	if (locale === "it") return /** @type {LocalizedString} */ ("Nome dell'oratore")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Имя докладчика")
	if (locale === "es") return /** @type {LocalizedString} */ ("Nombre del orador")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("演讲者姓名")
	if (locale === "ja") return /** @type {LocalizedString} */ ("講演者名")
	if (locale === "hi") return /** @type {LocalizedString} */ ("वक्ता का नाम")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Nome do palestrante")
	return /** @type {LocalizedString} */ ("Speaker Name")
});